import React from "react";
import Router from "next/router";
import { Modal, Button, message, Alert } from "antd";
import { GetPayList, GetPayDetail } from "$DATA/wallet";
import { getMemberInfo } from "$DATA/userinfo";
import { get } from "$ACTIONS/TlcRequest";
import { getAttemptVal } from "$ACTIONS/OTPUtil";
import { ApiPort } from "$ACTIONS/TLCAPI";
import HostConfig from "$ACTIONS/Host.config";
import { ARY_NEED_PII_KYC_CHECK } from "$ACTIONS/constantsData";
import { sendPiwikEvent, sendPiwikEventWithEventValue, sendPiwikUrl } from "$ACTIONS/PiwikUtil";
import { getPIIKYCDepositUIConfig } from "$ACTIONS/PIIKYCDepositUtil";
import CMSOBJ from "$DATA/stage.live.static.id";
import AddBankCard from "../BankAccount/AddBankCard";
import LB from "./depositComponents/LB";
import UP from "./depositComponents/UP";
import OA from "./depositComponents/OA";
import BC from "./depositComponents/BC";
import BCM from "./depositComponents/BCM";
import AP from "./depositComponents/AP";
import CC from "./depositComponents/CC";
import WC from "./depositComponents/WC";
import QQ from "./depositComponents/QQ";
import JDP from "./depositComponents/JDP";
import ALB from "./depositComponents/ALB";
import WCLB from "./depositComponents/WCLB";
import PPB from "./depositComponents/PPB";
import ODP from "./depositComponents/ODP";
import CTC from "./depositComponents/CTC";
import SR from "./depositComponents/SR";
import CardId from "@/RealyName/CardId";
import DepositLesson from "../DepositLesson";
import Announcement from "@/Announcement/";
import SelfExclusionModal from "../SelfExclusionModal";

function renderAddBankCard(visible, closeModalFunc, getMemberBanksListFunc) {
    return (
      <AddBankCard
         disableUserName={true}
         visible={visible}
         closeModal={closeModalFunc}
         getMemberBanksList={getMemberBanksListFunc}
      />
    );
}
class Deposit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 0, // 充值前置如缺失个人资料，则记录需要完善的步骤
            currDepositDetail: {}, // 当前的支付方式的详情
            isOpenRealyName: false, // 是否打开完善姓名
            isAddBankAccountModalVisible: false,
            userInfo: {
                userName: "",
                currency: "CNY",
                memberCode: "",
                isDeposited: 0, // 0 未存款，可更新  1 以存款，禁更新
                realyName: "",
                cardId: "",
                phoneNumber: "",
                isBankCardValidated: false,
                phoneStatus: false,
            },
            bcType: "", // 在线存款类型（快捷支付、网银支付）
            isShowLearnEntry: true,
            lessonModal: false,
            depositLessonTab: 1,
            submitOTPAttempts: 0,
            banksVerificationManual: false,
            announcement: false,
            newsList: {},
        };

        this.setPayListChild = this.setPayListChild.bind(this); // 设置当前已有的支付方式并获取默认支付方式的详情
        this.getDepositFrontData = this.getDepositFrontData.bind(this); // 获取前置数据（会员信息详情）
        this.openNotHasBankAccount = this.openNotHasBankAccount.bind(this); // 是否有可用的银行列表
        this.openIsSetRealyName = this.openIsSetRealyName.bind(this);
        this.depositStatusCheck = this.depositStatusCheck.bind(this); // 充值状态检测
        this.initPIIKYCDepositUI = this.initPIIKYCDepositUI.bind(this);
        this.showAddBankCardModal = this.showAddBankCardModal.bind(this);
        this.changeBcType = this.changeBcType.bind(this); // 在线存款类型更换
        this.thirdPartyPay = this.thirdPartyPay.bind(this); // 第三方支付成功回调
        this.closeAllModal = this.closeAllModal.bind(this); // 验证失败后需关闭全部弹窗
        this.exceedTryNumber = this.exceedTryNumber.bind(this); // 超过验证次数后的提示信息
        this.pushDepositGtag = this.pushDepositGtag.bind(this); // 充值方式教程gtag事件追踪

        this.isFinishFrontData = []; // 是否已获取完成当前Page所需前置数据

        global.DepositComponentInitPIIKYCDepositUI = this.initPIIKYCDepositUI;
        global.DepositComponentShowAddBankCardModal = this.showAddBankCardModal;
    }
    componentDidMount() {
        // 因为改了获取逻辑，充值方式通过之后需要检验是否会出现loading提前消失的问题
        this.getDepositFrontData(); // Get会员信息
        this.setPayListChild(); // Get充值方式
        //this.getNews();
        global.Pushgtagpiwikurl && global.Pushgtagpiwikurl("deposit");
    }

    showAddBankCardModal() {
        this.setState({isAddBankAccountModalVisible: true});
        /* phase2
        this.props.setLoading(true);
        get(ApiPort.GETMemberlistAPI).then(res => {
            this.props.setLoading(false);
            if (res?.result?.memberInfo?.firstName) {
                global.AddBankCardComponentSetUserNameValueAlsoDisable(res.result.memberInfo.firstName)
            }
            this.setState({isAddBankAccountModalVisible: true});
        });
        */
    }

    initPIIKYCDepositUI(res) {
        if (!res || !ARY_NEED_PII_KYC_CHECK.includes(this.props.currentDepositKey)) {
            return;
        }

        let result = res.result || {};
        let { depositBVStatusCheck, depositPIIStatus, depositKYCStatusCheck, depositKYCStatus } = result.setting || {};

        if (typeof depositKYCStatus === 'string') { // CXPC-1121 and CXPC-1152
            depositKYCStatus = depositKYCStatus.toUpperCase();
        }

        let conf = { depositBVStatusCheck, depositPIIStatus, depositKYCStatusCheck, depositKYCStatus }
        //conf.depositBVStatusCheck = true; conf.depositPIIStatus = false; conf.depositKYCStatusCheck = true; conf.depositKYCStatus='NO';
        //console.log(  'conf', conf);
        let { isShowLockContent, isShowReminder } = getPIIKYCDepositUIConfig(conf);

        this.props.setLockUIVisible(isShowLockContent, conf);
        this.props.setMoreWayViaVerifiedBankAndKYCVisible(isShowReminder, conf);

        if (isShowLockContent) {
            let PaymentMethod = this.props.currentDepositKey;
            sendPiwikUrl(`deposit_${PaymentMethod}_enforce_pii`, `${PaymentMethod} Enforce PII Page`)
        }
        if (isShowReminder) {
            let PaymentMethod = this.props.currentDepositKey;
            sendPiwikUrl(`deposit_${PaymentMethod}`, `${PaymentMethod} Deposit Page`)
        }
    }

    callGetPayDetail(isRefactorAlanCode) {
        this.setState({ currDepositDetail: {} }); // reset
        if (!isRefactorAlanCode) { this.props.setLoading(true); }
        const newLen = this.isFinishFrontData.push(0); // for isRefactorAlanCode is true
            GetPayDetail(
                this.props.currentDepositKey,
                (res) => {
                if (!isRefactorAlanCode) { this.props.setLoading(false); }
                    res &&
                        this.setState({ currDepositDetail: res.result }, () => {
                            this.initPIIKYCDepositUI(res);
                            //this.openNotHasBankAccount();
                        });
                    // this.props.setLoading(false);

                if (isRefactorAlanCode) {
                    this.isFinishFrontData.splice(newLen - 1, 1, 1);
                    this.isFinishFrontData.length &&
                        !~this.isFinishFrontData.indexOf(0) &&
                        this.props.setLoading(false);
                }
                },
                this.props.payMethodList
            );
        }

    componentDidUpdate(prevProps, prevState) {
        // 切换分类时获取对应充值方式详情

        if (
            prevProps.currentDepositKey !== this.props.currentDepositKey &&
            this.props.currentDepositKey !== ""
        ) {
            this.props.setLoading(true);

            this.callGetPayDetail(
                true
            );
        }
        if (prevProps.visible !== this.props.visible && this.props.visible) {
            this.depositStatusCheck(); // 重新开启弹窗默认检测是否通过前置条件
            if (
                this.props.dialogTabKey &&
                this.props.dialogTabKey.currentPayValue
            ) {
                this.props.setCurrentPayMethod(
                    this.props.dialogTabKey.currentPayValue
                );
            }
            //this.getNews();
        }
    }

    openIsSetRealyName(res) {
        // 充值需要完善个人信息的提示语
        let promiseArr = [];
        promiseArr.push(
            new Promise((resolve, reject) => {
                get(
                    ApiPort.GetOTPAttempts +
                    "&serviceAction=DepositVerification&channelType=SMS"
                )
                    .then((remain) => {
                        resolve(remain);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject();
                    });
            })
        );
        this.props.setLoading(true);

        Promise.all(promiseArr)
            .then((values) => {
                this.props.setLoading(false);
                let phoneStatus = "";
                console.log("----->", res);
                console.log("===========>", values);
                if (res.contacts) {
                    phoneStatus = res.contacts.some((v) => {
                        return (
                            v.contactType === "Phone" && v.status === "Verified"
                        );
                    });
                } else {
                    phoneStatus = res.phoneStatus;
                }

                let attempt = getAttemptVal(values[0]);

                if (!phoneStatus || !res.firstName) {
                    this.setState(
                        {
                            step: 1,
                            submitOTPAttempts: attempt,
                        },
                        () => {
                            this.setState({
                                isOpenRealyName:
                                    attempt > 0,
                            });
                        }
                    );
                }
                if (
                    this.state.step !== 2 &&
                    !attempt &&
                    !phoneStatus
                ) {
                    this.exceedTryNumber();
                }
            })
            .catch((err) => {
                console.log(err);
                this.props.setLoading(false);
                this.closeAllModal();
            });
    }
    openNotHasBankAccount() {
        this.props.currentDepositKey === "LB" &&
            Array.isArray(this.state.currDepositDetail.bankAccounts) &&
            !this.state.currDepositDetail.bankAccounts.length &&
            Modal.confirm({
                title: "温馨提示",
                icon: null,
                centered: true,
                okText: "刷新重试",
                cancelText: "知道了",
                content: (
                    <div style={{ textAlign: "left" }}>
                        抱歉， ！目前暂无可充值的银行，请尝试其他充值方式。
                    </div>
                ),
                onOk: () => {
                    this.props.setLoading(true);

                    GetPayDetail(this.props.currentDepositKey, (res) => {
                        this.props.setLoading(false);
                        res &&
                            this.setState(
                                { currDepositDetail: res.result },
                                () => {
                                    this.openNotHasBankAccount();
                                }
                            );
                    });
                },
                onCancel: () => {},
            });
    }
    exceedTryNumber(callback) {
        const phone = this.state.userInfo.phoneStatus;
        const call = () => {
            if ((typeof callback === "function" && callback()) || !phone) {
                this.closeAllModal();
            } else if (phone) {
                this.setState({
                    step: 2,
                    banksVerificationManual: true,
                });
            }
        };
        const callCancel = () => {
            if ((typeof callback === "function" && callback()) || !phone) {
                this.closeAllModal();
            } else if (phone) {
                exceedTryNumM.destroy();
            }
        };
        const exceedTryNumM = Modal.info({
            className: "confirm-modal-of-public wallet-deposit-warning",
            icon: <div />,
            title: "账户验证",
            width: 400,
            centered: true,
            okText: !phone ? "联系在线客服" : "手动绑定",
            content: (
                <div className="inline-link-btn">
                    <div>
                        <img src={"/cn/img/icons/icon-warn_yellow.png"} />
                    </div>
                    <div className="content" style={{ marginTop: 20 }}>
                        <h3 style={{ fontSize: "18px", fontWeight: "900" }}>
                            您已超过5次尝试
                        </h3>
                        {!phone && (
                            <p
                                style={{
                                    textAlign: "center",
                                    marginBottom: 30,
                                    color: "#666",
                                }}
                            >
                                请24小时之后再试或联系我们的在线客服进行验证。
                            </p>
                        )}
                        {phone && (
                            <p style={{ textAlign: "left", fontSize: 12 }}>
                                小同可以尝试手动绑定进行验证，或联系小同
                                <Button
                                    type="link"
                                    onClick={global.PopUpLiveChat}
                                >
                                    在线客服
                                </Button>
                                。
                            </p>
                        )}
                    </div>
                </div>
            ),
            onCancel: callCancel,
            onOk: () => {
                if (phone) {
                    call();
                } else {
                    global.PopUpLiveChat();
                    call();
                }
            },
        });
    }
    bonusApplication(res) {
        if (res.bonusApplicationMessage) {
            const content = (
                <span
                    dangerouslySetInnerHTML={{
                        __html: res.bonusApplicationMessage,
                    }}
                />
            );

            if (res.bonusResult === "Fail") {
                message.error({ content });
            } else {
                message.success({ content });
            }
        }
    }
    /**
     * 第三方支付成功回调
     * @param {object} res 响应信息
     * @param {function} closeCallback 第三方窗口关闭回调
     */
    thirdPartyPay(res, closeCallback, config={}) {
        this.bonusApplication(res);
        sessionStorage.removeItem("promoDeposit");
        const { currentDepositKey } = this.props;
        const methodList = ["BC", "BCM", "UP", "OA", "JDP", "WC", "QQ"];
        //const specialList = [ 'BC', 'BCM', 'UP', 'OA', 'JDP', 'WC' ];
        const otherMethodList = ["QQ"];
        //let flag = false,
        //otherFlag = false;
        //flag = methodList.includes(currentDepositKey);
        //otherFlag = otherMethodList.includes(currentDepositKey);
        const openNewWindow = () => {
            var RBWindow = window.open(
                "",
                "_blank",
                "toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=1245, height=559"
            );
            RBWindow.document.write(res.redirectUrl);
            RBWindow.focus();
        };

        //如果有手续费
        if (res.vendorCharges) {
            Modal.info({
                className: "confirm-modal-of-public",
                icon: <div />,
                title: "温馨提醒",
                centered: true,
                okText: "确认",
                width: "400px",
                content: (
                    <dl className="deposit-result">
                        <dt>订单{res.transactionId}创建成功。</dt>
                        <dt>此交易将征收第三方额外费用，详情如下。</dt>
                        <div className="line-distance" />
                        <div className="detail">
                            <dd>
                                存款金额：<span>{res.uniqueAmount || ""}</span>
                            </dd>
                            <dd>
                                第三方手续费：
                                <span>{Math.abs(res.charges) || ""}</span>
                            </dd>
                            <dd>
                                实际金额：<span>{res.actualAmount || ""}</span>
                            </dd>
                        </div>
                        {/* 含有交易免手续费 */}
                        {res.totalWaiveRemain > 0 && (
                            <div className="line-distance" />
                        )}
                        {res.totalWaiveRemain > 0 && (
                            <dt>
                                注意 : 交易成功后，才会扣除免手续费的次数。
                                <br />
                                剩余 <span>{res.totalWaiveRemain}</span>{" "}
                                笔交易免手续费。
                            </dt>
                        )}
                        <div className="line-distance" />
                        {currentDepositKey == "PPB" && (
                            <dt className="TextLightYellow">
                                乐天使温馨提醒:请在
                                {this.state.timeOutMin &&
                                this.state.timeOutMin != "0"
                                    ? `${this.state.timeOutMin}分钟`
                                    : ""}
                                {this.state.timeOutSec &&
                                this.state.timeOutSec != "0"
                                    ? `${this.state.timeOutSec}秒`
                                    : ""}
                                之内完成支付，以免到账延迟。​
                            </dt>
                        )}
                        {currentDepositKey == "QQ" && (
                            <dt className="TextLightYellow">
                                乐天使温馨提醒：请勿使用 QQ
                                添加陌生账号或是私自汇款给对方，以免遇到诈骗。如任何损失，本站一概不负责。​
                            </dt>
                        )}
                    </dl>
                ),
                onOk: () => {
                    openNewWindow(res, closeCallback);
                },
            });
        } else {
            //如果含有免费次数 所以手续费 0
            if (res.totalWaiveRemain > 0 && res.charges < 0) {
                Modal.info({
                    className: "confirm-modal-of-public",
                    icon: <div />,
                    title: "温馨提醒",
                    centered: true,
                    okText: "确认",
                    width: "400px",
                    content: (
                        <dl className="deposit-result">
                            {<dt>订单{res.transactionId}创建成功。</dt>}
                            <dt>
                                注意 : 交易成功后，才会扣除免手续费的次数。
                                <br />
                                剩余 <span>{res.totalWaiveRemain}</span>{" "}
                                笔交易免手续费。
                            </dt>
                            <div className="line-distance" />
                            {/* 网银转账显示 */}
                            {currentDepositKey == "PPB" && (
                                <dt className="TextLightYellow">
                                    乐天使温馨提醒:请在
                                    {this.state.timeOutMin &&
                                    this.state.timeOutMin != "0"
                                        ? `${this.state.timeOutMin}分钟`
                                        : ""}
                                    {this.state.timeOutSec &&
                                    this.state.timeOutSec != "0"
                                        ? `${this.state.timeOutSec}秒`
                                        : ""}
                                    之内完成支付，以免到账延迟。​
                                </dt>
                            )}
                            {/* QQ支付显示 */}
                            {currentDepositKey == "QQ" && (
                                <dt className="TextLightYellow">
                                    乐天使温馨提醒：请勿使用 QQ
                                    添加陌生账号或是私自汇款给对方，以免遇到诈骗。如任何损失，本站一概不负责。​
                                </dt>
                            )}
                        </dl>
                    ),
                    onOk: () => {
                        openNewWindow(res, closeCallback);
                    },
                });
            } else {
                if (
                    (res.totalWaiveRemain == 0 && res.charges == 0) ||
                    (res.totalWaiveRemain > 0 && res.charges == 0) ||
                    (res.totalWaiveRemain == 0 && res.charges > 0) ||
                    (res.totalWaiveRemain > 0 && res.charges > 0) ||
                    (res.totalWaiveRemain == 0 && res.charges < 0)
                ) {
                    /* 如果是QQ支付和网银转账 */
                    if (
                        (currentDepositKey == "QQ" && config.isOriginQQ) ||
                        currentDepositKey == "PPB"
                    ) {
                        Modal.info({
                            className: "confirm-modal-of-public",
                            icon: <div />,
                            title: "温馨提醒",
                            centered: true,
                            okText: "确认",
                            width: "400px",
                            content: (
                                <dl className="deposit-result">
                                    {<dt>订单{res.transactionId}创建成功。</dt>}
                                    <div className="line-distance" />
                                    {/* 网银转账显示 */}
                                    {currentDepositKey == "PPB" && (
                                        <dt className="TextLightYellow">
                                            乐天使温馨提醒:请在
                                            {this.state.timeOutMin &&
                                            this.state.timeOutMin != "0"
                                                ? `${this.state.timeOutMin}分钟`
                                                : ""}
                                            {this.state.timeOutSec &&
                                            this.state.timeOutSec != "0"
                                                ? `${this.state.timeOutSec}秒`
                                                : ""}
                                            之内完成支付，以免到账延迟。​
                                        </dt>
                                    )}
                                    {/* QQ支付显示 */}
                                    {currentDepositKey == "QQ" && (
                                        <dt className="TextLightYellow">
                                            乐天使温馨提醒：请勿使用 QQ
                                            添加陌生账号或是私自汇款给对方，以免遇到诈骗。如任何损失，本站一概不负责。​
                                        </dt>
                                    )}
                                </dl>
                            ),
                            onOk: () => {
                                openNewWindow();
                            },
                        });
                    } else {
                        openNewWindow();
                    }
                } else {
                    openNewWindow();
                }
            }
        }

        // if (res.vendorCharges) {
        // 	Modal.info({
        // 		className: 'confirm-modal-of-public',
        // 		icon: <div />,
        // 		title: '温馨提醒',
        // 		centered: true,
        // 		okText: '确认',
        // 		width: '400px',
        // 		content: (
        // 			<dl className="deposit-result">
        // 				{flag ? <dt>订单{res.transactionId}创建成功。</dt> : null}
        // 				{flag ? <dt>此交易将征收第三方额外费用，详情如下。</dt> : null}
        // 				{flag && Math.abs(res.charges) > 0 ? <div className="line-distance" /> : null}
        // 				{flag ? (
        // 					<div className="detail">
        // 						<dd>
        // 							存款金额：<span>{res.uniqueAmount || ''}</span>
        // 						</dd>
        // 						<dd>
        // 							第三方手续费：<span>{Math.abs(res.charges) || ''}</span>
        // 						</dd>
        // 						<dd>
        // 							实际金额：<span>{res.actualAmount || ''}</span>
        // 						</dd>
        // 					</div>
        // 				) : null}
        // 				{flag && res.totalWaiveRemain > 0 ? <div className="line-distance" /> : null}
        // 				{flag && res.totalWaiveRemain > 0 ? (
        // 					<dt>
        // 						注意 : 交易成功后，才会扣除免手续费的次数。<br />剩余 <span>{res.totalWaiveRemain}</span> 笔交易免手续费。
        // 					</dt>
        // 				) : null}
        // 				<div className="line-distance" />
        // 				{currentDepositKey == 'PPB' ? (
        // 					<dt className="TextLightYellow">
        // 						乐天使温馨提醒:请在{' '}
        // 						{this.state.timeOutMin && this.state.timeOutMin != '0' ? (
        // 							`${this.state.timeOutMin}分钟`
        // 						) : (
        // 							''
        // 						)}{' '}
        // 						{this.state.timeOutSec && this.state.timeOutSec != '0' ? (
        // 							`${this.state.timeOutSec}秒`
        // 						) : (
        // 							''
        // 						)}{' '}
        // 						之内完成支付，以免到账延迟。​
        // 					</dt>
        // 				) : null}
        // 				{currentDepositKey == 'QQ' ? (
        // 					<dt className="TextLightYellow">乐天使温馨提醒：请勿使用 QQ 添加陌生账号或是私自汇款给对方，以免遇到诈骗。如任何损失，乐天堂一概不负责。​</dt>
        // 				) : null}
        // 			</dl>
        // 		),
        // 		onOk: () => {
        // 			openNewWindow(res, closeCallback);
        // 		}
        // 	});
        // } else {
        // 	//没有第三方额外费用
        // 	if (specialList.includes(currentDepositKey) && res.totalWaiveRemain == 0) {
        // 		if (currentDepositKey === 'BC') {
        // 			openNewWindow();
        // 		}
        // 	} else if (currentDepositKey === 'QQ' && res.totalWaiveRemain >= 0 && res.charges >= 0) {
        // 		Modal.info({
        // 			icon: null,
        // 			centered: true,
        // 			type: 'confirm',
        // 			btnBlock: true,
        // 			btnReverse: true,
        // 			title: '温馨提醒',
        // 			okText: '我知道了',
        // 			onlyOKBtn: true,
        // 			className: 'confirm-modal-of-public',
        // 			content: (
        // 				<React.Fragment>
        // 					<dl className="deposit-result">
        // 						<dt>订单{res.transactionId}创建成功。</dt>
        // 						<div className="line-distance" />
        // 						<dt className="TextLightYellow">
        // 							乐天使温馨提醒：请勿使用 QQ 添加陌生账号或是私自汇款给对方，以免遇到诈骗。如任何损失，乐天堂一概不负责。​
        // 						</dt>
        // 					</dl>
        // 				</React.Fragment>
        // 			),
        // 			onOk: () => {
        // 				openNewWindow();
        // 			}
        // 		});
        // 		return;
        // 	} else if (currentDepositKey === 'QQ' && res.totalWaiveRemain == 0 && res.charges < 0) {
        // 		Modal.info({
        // 			icon: null,
        // 			centered: true,
        // 			type: 'confirm',
        // 			btnBlock: true,
        // 			btnReverse: true,
        // 			title: '存款',
        // 			okText: '我知道了',
        // 			onlyOKBtn: true,
        // 			className: 'confirm-modal-of-public',
        // 			content: (
        // 				<React.Fragment>
        // 					<dl className="deposit-result">
        // 						<dt>订单{res.transactionId}创建成功。</dt>
        // 						<div className="line-distance" />
        // 						<dt className="TextLightYellow">
        // 							乐天使温馨提醒：请勿使用 QQ 添加陌生账号或是私自汇款给对方，以免遇到诈骗。如任何损失，乐天堂一概不负责。​
        // 						</dt>
        // 					</dl>
        // 				</React.Fragment>
        // 			),
        // 			onOk: () => {
        // 				openNewWindow();
        // 			}
        // 		});
        // 		return;
        // 	} else if (currentDepositKey === 'QQ' && res.totalWaiveRemain > 0 && res.charges < 0) {
        // 		Modal.info({
        // 			icon: null,
        // 			centered: true,
        // 			type: 'confirm',
        // 			btnBlock: true,
        // 			btnReverse: true,
        // 			title: '存款',
        // 			okText: '我知道了',
        // 			onlyOKBtn: true,
        // 			className: 'confirm-modal-of-public',
        // 			content: (
        // 				<React.Fragment>
        // 					<dl className="deposit-result">
        // 						<dt>订单{res.transactionId}创建成功。</dt>
        // 						<div className="line-distance" />
        // 						<dt>
        // 							注意 : 交易成功后，才会扣除免手续费的次数。<br />剩余 <span>{res.totalWaiveRemain}</span> 笔交易免手续费。
        // 						</dt>
        // 						<div className="line-distance" />
        // 						<dt className="TextLightYellow">
        // 							乐天使温馨提醒：请勿使用 QQ 添加陌生账号或是私自汇款给对方，以免遇到诈骗。如任何损失，乐天堂一概不负责。​
        // 						</dt>
        // 					</dl>
        // 				</React.Fragment>
        // 			),
        // 			onOk: () => {
        // 				openNewWindow();
        // 			}
        // 		});
        // 		return;
        // 	} else if (currentDepositKey === 'PPB' && res.totalWaiveRemain >= 0 && res.charges >= 0) {
        // 		Modal.info({
        // 			icon: null,
        // 			centered: true,
        // 			type: 'confirm',
        // 			btnBlock: true,
        // 			btnReverse: true,
        // 			title: '存款',
        // 			okText: '我知道了',
        // 			onlyOKBtn: true,
        // 			className: 'confirm-modal-of-public',
        // 			content: (
        // 				<React.Fragment>
        // 					<dl className="deposit-result">
        // 						<dt>订单{res.transactionId}创建成功。</dt>
        // 						<div className="line-distance" />
        // 						<dt className="TextLightYellow">
        // 							乐天使温馨提醒:请在{' '}
        // 							{this.state.timeOutMin && this.state.timeOutMin != '0' ? (
        // 								`${this.state.timeOutMin}分钟`
        // 							) : (
        // 								''
        // 							)}{' '}
        // 							{this.state.timeOutSec && this.state.timeOutSec != '0' ? (
        // 								`${this.state.timeOutSec}秒`
        // 							) : (
        // 								''
        // 							)}{' '}
        // 							之内完成支付，以免到账延迟。​
        // 						</dt>
        // 					</dl>
        // 				</React.Fragment>
        // 			),
        // 			onOk: () => {
        // 				openNewWindow();
        // 			}
        // 		});
        // 		return;
        // 	} else if (currentDepositKey === 'PPB' && res.totalWaiveRemain == 0 && res.charges < 0) {
        // 		Modal.info({
        // 			icon: null,
        // 			centered: true,
        // 			type: 'confirm',
        // 			btnBlock: true,
        // 			btnReverse: true,
        // 			title: '存款',
        // 			okText: '我知道了',
        // 			onlyOKBtn: true,
        // 			className: 'confirm-modal-of-public',
        // 			content: (
        // 				<React.Fragment>
        // 					<dl className="deposit-result">
        // 						<dt>订单{res.transactionId}创建成功。</dt>
        // 						<div className="line-distance" />
        // 						<dt className="TextLightYellow">
        // 							乐天使温馨提醒:请在{' '}
        // 							{this.state.timeOutMin && this.state.timeOutMin != '0' ? (
        // 								`${this.state.timeOutMin}分钟`
        // 							) : (
        // 								''
        // 							)}{' '}
        // 							{this.state.timeOutSec && this.state.timeOutSec != '0' ? (
        // 								`${this.state.timeOutSec}秒`
        // 							) : (
        // 								''
        // 							)}{' '}
        // 							之内完成支付，以免到账延迟。​
        // 						</dt>
        // 					</dl>
        // 				</React.Fragment>
        // 			),
        // 			onOk: () => {
        // 				openNewWindow();
        // 			}
        // 		});
        // 		return;
        // 	} else if (currentDepositKey === 'PPB' && res.totalWaiveRemain > 0 && res.charges < 0) {
        // 		Modal.info({
        // 			icon: null,
        // 			centered: true,
        // 			type: 'confirm',
        // 			btnBlock: true,
        // 			btnReverse: true,
        // 			title: '存款',
        // 			okText: '我知道了',
        // 			onlyOKBtn: true,
        // 			className: 'confirm-modal-of-public',
        // 			content: (
        // 				<React.Fragment>
        // 					<dl className="deposit-result">
        // 						<dt>订单{res.transactionId}创建成功。</dt>
        // 						<div className="line-distance" />
        // 						<dt>
        // 							注意 : 交易成功后，才会扣除免手续费的次数。<br />剩余 <span>{res.totalWaiveRemain}</span> 笔交易免手续费。
        // 						</dt>
        // 						<div className="line-distance" />
        // 						<dt className="TextLightYellow">
        // 							乐天使温馨提醒:请在{' '}
        // 							{this.state.timeOutMin && this.state.timeOutMin != '0' ? (
        // 								`${this.state.timeOutMin}分钟`
        // 							) : (
        // 								''
        // 							)}{' '}
        // 							{this.state.timeOutSec && this.state.timeOutSec != '0' ? (
        // 								`${this.state.timeOutSec}秒`
        // 							) : (
        // 								''
        // 							)}{' '}
        // 							之内完成支付，以免到账延迟。​
        // 						</dt>
        // 					</dl>
        // 				</React.Fragment>
        // 			),
        // 			onOk: () => {
        // 				openNewWindow();
        // 			}
        // 		});
        // 		return;
        // 	} else if (
        // 		currentDepositKey !== 'PPB' &&
        // 		currentDepositKey !== 'QQ' &&
        // 		res.totalWaiveRemain > 0 &&
        // 		res.charges < 0
        // 	) {
        // 		Modal.info({
        // 			icon: null,
        // 			centered: true,
        // 			type: 'confirm',
        // 			btnBlock: true,
        // 			btnReverse: true,
        // 			title: '存款',
        // 			okText: '我知道了',
        // 			onlyOKBtn: true,
        // 			className: 'confirm-modal-of-public',
        // 			content: (
        // 				<React.Fragment>
        // 					<dl className="deposit-result">
        // 						<dt>订单{res.transactionId}创建成功。</dt>
        // 						<div className="line-distance" />
        // 						<dt>
        // 							注意 : 交易成功后，才会扣除免手续费的次数。<br />剩余 <span>{res.totalWaiveRemain}</span> 笔交易免手续费。
        // 						</dt>
        // 						<div className="line-distance" />
        // 					</dl>
        // 				</React.Fragment>
        // 			),
        // 			onOk: () => {
        // 				openNewWindow();
        // 			}
        // 		});
        // 		return;
        // 	} else {
        // 		openNewWindow();
        // 	}
        // }
    }
    depositStatusCheck(type, bankCode) {
        let memberInfo = JSON.parse(localStorage.getItem("memberInfo"));
        memberInfo &&
            (memberInfo.phoneStatus = memberInfo.contacts.some((v) => {
                return v.contactType === "Phone" && v.status === "Verified";
            }));
        if (!memberInfo.phoneStatus || !memberInfo.firstName) {
            this.openIsSetRealyName(memberInfo);
            return undefined;
        }
        // 以下情况需要判定是否需要判定收款或者存款銀行（本地银行，在线支付网银存款，支付宝转账）
        if (type === "LB" && type === "SR" && bankCode === "") {
            this.openNotHasBankAccount();
            return undefined;
        }
        if (
            (type === "BC" || type === "BCM" || type === "ALB") &&
            bankCode === ""
        ) {
            // 网银存款收款银行为空的情况下退出操作！
            message.error(" 暂时无法使用此充值方式，请先使用其他充值方式哦"); // 统一三端提示信息
            return undefined;
        }
        return true;
    }
    // 获取充值前置信息（会员真实姓名完善情况）
    getDepositFrontData() {
        this.props.setLoading(true);

        const newLen = this.isFinishFrontData.push(0);
        getMemberInfo((res) => {
            console.log("-------------->", res);
            let phoneNumber = "";
            const phoneStatus = res.contacts
                ? res.contacts.some((v) => {
                      const inPhoneStatus = v.contactType === "Phone";
                      inPhoneStatus &&
                          (phoneNumber = v.contact.replace("86-", ""));
                      return inPhoneStatus && v.status === "Verified";
                  })
                : false;

            this.setState(
                {
                    userInfo: {
                        userName: res.userName,
                        currency: res.currency,
                        memberCode: res.memberCode,
                        isDeposited: res.isDeposited,
                        realyName: res.firstName,
                        cardId: res && Object.prototype.hasOwnProperty.call(res, 'identityCard') ? res.identityCard : res.documentID,
                        isBankCardValidated: res.isBankCardValidated,
                        phoneNumber: phoneNumber,
                        phoneStatus: phoneStatus,
                    },
                },
                () => {
                    if (!phoneStatus || !res.firstName) {
                        this.openIsSetRealyName(res);
                    }
                }
            );

            this.isFinishFrontData.splice(newLen - 1, 1, 1);
            this.isFinishFrontData.length &&
                !~this.isFinishFrontData.indexOf(0) &&
                this.props.setLoading(false);
        }, true);
    }
    closeAllModal() {
        Modal.destroyAll();
        this.props.onCancel();
        this.setState({ isOpenRealyName: false });
    }
    // 获取并设置充值方式、获取默认支付详情
    setPayListChild(key = true) {
        this.props.setLoading(true);
        let defaultType =
            (this.props.dialogTabKey &&
                this.props.dialogTabKey.currentPayValue) ||
            "LB";
        if (
            Array.isArray(this.props.payMethodList) &&
            this.props.payMethodList.length &&
            key
        ) {
            GetPayDetail(
                this.props.currentDepositKey,
                (res) => {
                    //this.props.setLoading(false);

                    res && this.setState({ currDepositDetail: res.result });
                },
                this.props.payMethodList
            );
            return null;
        }

        const newLen = this.isFinishFrontData.push(0);

        GetPayList((res) => {
            if (res.result) {
                this.props.setPayList(res.result.paymentMethods, defaultType);
                this.props.setIsDeShowBankCardVerif(
                    res.allowBankcardVerification
                );
            }
            this.isFinishFrontData.splice(newLen - 1, 1, 1);

            this.isFinishFrontData.length &&
                !~this.isFinishFrontData.indexOf(0) &&
                this.props.setLoading(false);
        });
    }

    // 在线存款类型更换
    changeBcType(v, status) {
        // Pushgtagdata(
        //     v === "BC"
        //         ? "CDC_onlinebankpay_deposit"
        //         : "mobileCDC_onlinebankpay_deposit"
        // );
        if (status === true) {
            return this.setState({ bcType: v });
        }
        this.props.setLoading(true);

        GetPayDetail(v, (res) => {
            this.props.setLoading(false);
            res &&
                this.setState({
                    bcType: v,
                    currDepositDetail: res.result,
                });
        });
    }
    pushDepositGtag() {
        switch (this.props.currentDepositKey) {
            case "LB":
                Pushgtagdata("Tutorial_Localbank_deposit");
                break;
            case "JDP":
                Pushgtagdata("Tutorial_JDwallet_deposit");
                break;
            case "UP":
                Pushgtagdata("Tutorial_Unionpay_deposit");
                break;
            case "CTC":
                Pushgtagdata("Tutorial_crypto_deposit");
                break;
            case "PPB":
                Pushgtagdata("Tutorial_P2Pbanking_deposit");
                break;
            case "ODP":
                Pushgtagdata("Tutorial_ODPbanking_deposit");
                break;
            case "CC":
                Pushgtagdata("Tutorial_TLCcard_deposit");
                break;
            case "AP":
                Pushgtagdata("Tutorial_astropay_deposit");
                break;
            case "WC":
                Pushgtagdata("Tutorial_Onlinewechatpay_deposit");
                break;
            case "WCLB":
                Pushgtagdata("Tutorial_Localwechatpay_deposit");
                break;
            case "QQ":
                Pushgtagdata("Tutorial_onlineQQpay_deposit");
                break;
            case "OA":
                Pushgtagdata("Tutorial_Onlinealipay_deposit");
                break;
            case "ALB":
                Pushgtagdata("Tutorial_Localalipay_deposit");
                break;
            case "BCM":
            case "BC":
                Pushgtagdata("Tutorial_onlinebankpay_deposit");
                break;
            default:
                break;
        }
    }

    handleCancel = () => {
        this.setState({ lessonModal: false });
    };

    handleCtcMethodChange = (method) => {
        if (method == "INVOICE") {
            this.setState({ depositLessonTab: 2 });
        } else if (method == "CHANNEL") {
            this.setState({ depositLessonTab: 1 });
        } else if (method == "OTC") {
            this.setState({ depositLessonTab: 3 });
        }
    };

    handleChangeDepositLessonTab = (n) => {
        this.setState({ depositLessonTab: n });
        switch (n) {
            case "1":
                Pushgtagdata("Channel_tutorial_crypto");
                break;
            case "2":
                Pushgtagdata("Invoice_tutorial_crypto");
                break;
            case "3":
                Pushgtagdata("OTC_tutorial_crypto");
                break;
            default:
                break;
        }
    };
    /**
     * 已有部分充值方式再获取更多充值方式的验证
     */
    openBankAccountVerif = () => {
        this.props.setLoading(true);

        get(
            ApiPort.GetOTPAttempts +
                "&serviceAction=BankCardValidation&channelType=SMS"
        )
            .then((res) => {
                if (res) {
                    let attempt = getAttemptVal(res);
                    const bool = attempt > 0;
                    if (
                        /* see doc: /wiki/x/Ji6jAw
                        res.submitOTPAttempts < 1 ||
                        res.requestOTPAttempts < 1
                        */
                        !bool
                    ) {
                        this.props.setLoading(false);
                        this.exceedTryNumber();
                    } else {
                        get(ApiPort.GetBankcardVerificationAttempts)
                            .then((res) => {
                                this.props.setLoading(false);
                                if (res.isSuccess) {
                                    if (res.bankcardVerificationAttempts < 1) {
                                        this.exceedTryNumber();
                                    } else {
                                        this.setState(
                                            {
                                                step: 2,
                                                submitOTPAttempts:
                                                    res.bankcardVerificationAttempts,
                                            },
                                            () => {
                                                Modal.confirm({
                                                    title: "",
                                                    icon: null,
                                                    width: 400,
                                                    centered: true,
                                                    okText: "立即验证",
                                                    cancelText: "稍后验证",
                                                    content: (
                                                        <div>
                                                            <div>
                                                                <img
                                                                    src={
                                                                        "/cn/img/icons/icon-warn.png"
                                                                    }
                                                                />
                                                            </div>
                                                            <div
                                                                className="content"
                                                                style={{
                                                                    textAlign:
                                                                        "center",
                                                                    marginTop: 20,
                                                                }}
                                                            >
                                                                <p>
                                                                    {" "}
                                                                    ,
                                                                    请完成您的个人信息验证,
                                                                    以便开通更多的充值和提现方式哦。
                                                                </p>
                                                            </div>
                                                        </div>
                                                    ),
                                                    onOk: () => {
                                                        this.setState({
                                                            isOpenRealyName: true,
                                                        });
                                                    },
                                                });
                                            }
                                        );
                                    }
                                } else {
                                    message.error(
                                        "开启失败请稍后再试，或者联系在线客服！"
                                    );
                                }
                            })
                            .catch((err) => {
                                this.props.setLoading(false);
                                console.log(err);
                            });
                    }
                }
            })
            .catch((err) => {
                this.props.setLoading(false);
                console.log(err);
            });
        Pushgtagdata("Verification​", "Click", "IWMM_PII_DepositPage​");
    };

    render() {
        let depositContent = null;
        const { currDepositDetail, bcType, userInfo, banksVerificationManual } =
            this.state;

        // 子元素公用Props数据
        const depositChildrenProps = {
            setLoading: this.props.setLoading,
            setPromoBannerVisible: this.props.setPromoBannerVisible,
            dialogTabKey: this.props.dialogTabKey,
            payMethodList: this.props.payMethodList,
            depositStatusCheck: this.depositStatusCheck,
            thirdPartyPay: this.thirdPartyPay,
            bonusApplication: this.bonusApplication,
            currDepositDetail: currDepositDetail,
            setCurrDepositDetail: (result) => {
                console.log("支付方式详情---------->", result);
                this.setState({ currDepositDetail: result });
            },
            onCancel: this.props.onCancel,
            goUserCenter: this.props.goUserCenter,
            isShowBankCardVerif: this.props.isDeShowBankCardVerif,
            openBankAccountVerif: this.openBankAccountVerif,
        };

        switch (this.props.currentDepositKey) {
            case "LB": // 本银支付
                depositContent = (
                    <LB
                        {...depositChildrenProps}
                        localMemberName={userInfo.realyName}
                        setCurrentPayMethod={this.props.setCurrentPayMethod}
                    />
                );
                break;
            case "WCLB": // 微转账
                depositContent = (
                    <WCLB
                        {...depositChildrenProps}
                        setCurrentPayMethod={this.props.setCurrentPayMethod}
                    />
                );
                break;
            case "UP": // 银联支付
                depositContent = <UP {...depositChildrenProps} />;
                break;
            case "OA": // 在线支付宝
                depositContent = <OA {...depositChildrenProps} />;
                break;
            case "WC": // 微支付
                depositContent = <WC {...depositChildrenProps} />;
                break;
            case "QQ": // QQ支付
                depositContent = <QQ {...depositChildrenProps} />;
                break;
            case "BC": // 在线支付（网银支付）
                depositContent = (
                    <BC
                        {...depositChildrenProps}
                        bcType={bcType}
                        bcTypeList={this.props.bcPayList}
                        changeBcType={this.changeBcType}
                    />
                );
                break;
            case "BCM": // 在线支付（快捷支付）
                depositContent = (
                    <BCM
                        {...depositChildrenProps}
                        bcType={bcType}
                        bcTypeList={this.props.bcPayList}
                        changeBcType={this.changeBcType}
                    />
                );
                break;
            case "ALB": // 支付宝转账
                depositContent = (
                    <ALB
                        {...depositChildrenProps}
                        localMemberName={userInfo.realyName}
                        setCurrentPayMethod={this.props.setCurrentPayMethod}
                    />
                );
                break;
            case "CTC": // ticket3345虚拟货币 //加密货币
                depositContent = (
                    <CTC
                        {...depositChildrenProps}
                        localMemberName={userInfo.realyName}
                        setPromptInfo={this.props.setPromptInfo}
                        onCtcMethodChange={this.handleCtcMethodChange}
                        toggleLearnEntry={(status) => {
                            this.setState({ isShowLearnEntry: status });
                        }}
                        //tutorial={() => { Router.push("/cn/Help?type=Sub1&key=" + CMSOBJ[HostConfig.CMS_ID][this.props.currentDepositKey === "CTC" ? 43 : 16]) }}
                        tutorial={() => {
                            this.setState({ lessonModal: true });
                        }}
                    />
                );
                break;
            case "JDP": // 京东支付
                depositContent = <JDP {...depositChildrenProps} />;
                break;
            case "AP": // AstroPay
                depositContent = <AP {...depositChildrenProps} />;
                break;
            case "CC": // 同乐卡
                depositContent = <CC {...depositChildrenProps} />;
                break;
            case "PPB": // 网银转账
                depositContent = (
                    <PPB
                        {...depositChildrenProps}
                        bcTypeList={this.props.bcPayList}
                    />
                );
                break;
            case "ODP": // 网银存款
                depositContent = (
                    <ODP
                        {...depositChildrenProps}
                        bcTypeList={this.props.bcPayList}
                        setCurrentPayMethod={this.props.setCurrentPayMethod}
                    />
                );
                break;
            case "SR": // 小额充值
                depositContent = (
                    <SR
                        {...depositChildrenProps}
                        localMemberName={userInfo.realyName}
                        setCurrentPayMethod={this.props.setCurrentPayMethod}
                    />
                );
                break;
            default:
                break;
        }

        return (
            <React.Fragment>
                <CardId
                    className="wallet-deposit"
                    step={this.state.step}
                    userInfo={this.state.userInfo}
                    submitOTPAttempts={this.state.submitOTPAttempts}
                    realyNameVisible={this.state.isOpenRealyName}
                    nextStep={(v) => {
                        this.setState({ step: v });
                    }}
                    verifySuccess={(v) => {
                        this.setState({ isOpenRealyName: v });
                    }}
                    setSubmitOTPAttempts={(v) => {
                        this.setState({ submitOTPAttempts: v });
                    }}
                    onChangeUserInfo={(v) => this.setState({ userInfo: v })}
                    closeAllModal={this.closeAllModal}
                    exceedTryNumber={this.exceedTryNumber}
                    setLoading={this.props.setLoading}
                    getPayMethod={this.setPayListChild}
                    banksVerificationManual={banksVerificationManual}
                    setBanksVerificationManual={(v) => {
                        this.setState({ banksVerificationManual: v });
                    }}
                    GetThroughoutVerification={() => {
                        this.props.GetThroughoutVerification();
                    }}
                />
                {/* {this.props.currentDepositKey != 'CTC' &&
					(this.state.isShowLearnEntry ? (
						<a
							className="deposit-help-link"
							onClick={() => {
								Router.push(
									'/cn/Help?type=Sub1&key=' +
										CMSOBJ[HostConfig.CMS_ID][this.props.currentDepositKey === 'CTC' ? 43 : 16]
								);
								this.pushDepositGtag;
							}}
						>
							查看充值教学
						</a>
					) : null)} */}
				{this.props.currentDepositKey == 'CTC' && (
					<a
						className="deposit-help-link"
						onClick={() => {
							this.setState({ lessonModal: true });
						}}
					>
						查看存款教程
					</a>
				)}
				{depositContent}
				{renderAddBankCard(this.state.isAddBankAccountModalVisible, ()=>{
					this.setState({ isAddBankAccountModalVisible: false });
					}, ()=>{
					this.callGetPayDetail();
					})}
				<Modal
					footer={null}
					maskClosable={true}
					onCancel={this.handleCancel}
					visible={this.state.lessonModal}
					//className='noDepositTip'
					width={960}
                    title="泰达币存款教程"
                    centered={true}
				>
					<DepositLesson
						onhandleCancel={this.handleCancel}
						tabNum={this.state.depositLessonTab}
						handleChangeDepositLessonTab={this.handleChangeDepositLessonTab}
					/>
				</Modal>
				{/* 紧急公告弹窗 */}
				<Announcement optionType="Deposit" />
				<SelfExclusionModal
					ModalType={1}
					OpenModalUrl="Deposit"
					afterCloseModal={() => {
						this.props.onCancel();
						Router.push('/cn');
					}}
				/>
			</React.Fragment>
		);
	}
}
export default Deposit;
